/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customerWalletInvoiceTopup } from '../../axios/customerWalletInvoiceTopup'
import type {
	CustomerWalletInvoiceTopupError,
	CustomerWalletInvoiceTopupPathParams,
	CustomerWalletInvoiceTopupRequest,
	CustomerWalletInvoiceTopupResponse,
} from '../../types/CustomerWalletInvoiceTopup'

export const customerWalletInvoiceTopupMutationKey = () => [{ url: '/:organisation/wallet/invoice-topup' }] as const

export type CustomerWalletInvoiceTopupMutationKey = ReturnType<typeof customerWalletInvoiceTopupMutationKey>

export type CustomerWalletInvoiceTopupVariables = {
	organisation: CustomerWalletInvoiceTopupPathParams['organisation']
	data: CustomerWalletInvoiceTopupRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::invoiceTopup */
export function useCustomerWalletInvoiceTopup<TContext = unknown>(
	options?: UseMutationOptions<
		CustomerWalletInvoiceTopupResponse,
		AxiosError<CustomerWalletInvoiceTopupError>,
		CustomerWalletInvoiceTopupVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: customerWalletInvoiceTopupMutationKey(),
		mutationFn: ({ organisation, data }: CustomerWalletInvoiceTopupVariables) =>
			customerWalletInvoiceTopup(organisation, data, config).then(res => res.data),
		...options,
	})
}
